import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {StackParamList} from '../../../../navigators';
import {SuccessTemplate} from '../../../../components/templates/success';
import {PrimaryButton, SecondaryButton} from '../../../../components/buttons';
import {message} from '../../../../utils/messages';
import {useContextState} from '../../../../context/user';
import {Role} from '../../../../constants/enumerations';

type ScreenProps = NativeStackScreenProps<StackParamList, 'ProofSuccess'>;

export const ProofSuccessScreen = ({navigation}: ScreenProps) => {
  const {profile} = useContextState();

  const clientDashboardIndex = 2;
  const clientProofPaymentIndex = 1;

  const handlePrimaryPress = async () => {
    if (profile?.role === Role.salesman) {
      navigation.pop(clientDashboardIndex);
    } else {
      navigation.reset({
        index: 0,
        routes: [{name: 'Dashboard'}],
      });
    }
  };

  const handleSecondaryPress = () => {
    if (profile?.role === Role.salesman) {
      navigation.pop(clientProofPaymentIndex);
    } else {
      navigation.reset({
        index: 0,
        routes: [{name: 'ProofPayment'}],
      });
    }
  };

  return (
    <SuccessTemplate
      title={message('proof-success-title')}
      summary={message('proof-success-summary')}>
      <PrimaryButton
        label={message('proof-success-primary-button')}
        onPress={() => handlePrimaryPress()}
      />
      <SecondaryButton
        label={message('proof-success-secondary-button')}
        mt="5"
        onPress={() => handleSecondaryPress()}
      />
    </SuccessTemplate>
  );
};
